import { render, staticRenderFns } from "./FilesFilters.vue?vue&type=template&id=5222cfcd&"
import script from "./FilesFilters.vue?vue&type=script&lang=js&"
export * from "./FilesFilters.vue?vue&type=script&lang=js&"
import style0 from "./FilesFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5222cfcd')) {
      api.createRecord('5222cfcd', component.options)
    } else {
      api.reload('5222cfcd', component.options)
    }
    module.hot.accept("./FilesFilters.vue?vue&type=template&id=5222cfcd&", function () {
      api.rerender('5222cfcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/files/FilesFilters.vue"
export default component.exports